import { render, staticRenderFns } from "./HomeNuevo.vue?vue&type=template&id=0a8fb2ca"
import script from "./HomeNuevo.vue?vue&type=script&lang=js"
export * from "./HomeNuevo.vue?vue&type=script&lang=js"
import style0 from "./HomeNuevo.vue?vue&type=style&index=0&id=0a8fb2ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports